module.exports = __webpack_public_path__ + "media/images/logo/Logo-5dde98b5f69a1592c37e08b92c9d28bf.png";